export function testimonialSlider() {
    let $testinmonialSlider = $(".testimonial-list");
    let $win = $(window);

    let initTestimonialSlider = function () {
        $testinmonialSlider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: true,
            arrows: false,
            mobileFirst: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 744,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: "unslick",
                },
            ],
        });
    }

    if ($testinmonialSlider.offset().top - $win.scrollTop() < 400 && $win.width() < 1200) {
        initTestimonialSlider();
    }

    $win.on("scroll", function() {
        if ($testinmonialSlider.offset().top - $win.scrollTop() < 400 && !$testinmonialSlider.hasClass("slick-initialized") && $win.width() < 1200) {
            initTestimonialSlider();
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialSlider.js